 $('.anouncement-slides').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true
});

 $('.home-banner-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
   dots: false,
  autoplay: true
});

$('.home-feature-outer').slick({
    arrows: false,
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 0,  // Infinite scrolling effect
    speed: 3000,  // Control speed of the sliding effect
    infinite: true,
    variableWidth: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: 'linear',  // Ensures smooth continuous scrolling
    centerMode: true,   // Helps avoid empty spaces
    autoplaySpeed: 0,   // Creates a seamless effect
    focusOnSelect: false
});
 $('.home-reviews-right, .installer-steps-wrapper').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
   dots: false,
  autoplay: false,
   infinite:false,
   responsive: [
      {
        breakpoint: 600,
        settings: {
          dots: true,
          slidesToShow: 2,   // Ensure only 1 slide is shown
        slidesToScroll: 1,
        variableWidth: true
        }
      },
   {
  breakpoint: 480,
settings: {
  dots: true,
  slidesToShow: 1.7,
  slidesToScroll: 1,
  infinite: false
}
}
    ]
});

 $('.satisfied-slides').slick({
  slidesToShow: 4,
    infinite: false,
  slidesToScroll: 1,
  arrows: true,
   dots: false,
  autoplay: false,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1.3,
        }
      }
    ]
});
$('.whatinbox-slides').slick({
  slidesToShow: 4,
    infinite: false,
  slidesToScroll: 1,
  arrows: true,
   dots: false,
  autoplay: false,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1.5,
        }
      }
    ]
});
$('.trusted-reviews-slider').slick({
  slidesToShow: 4,
    infinite: false,
  slidesToScroll: 1,
  arrows: true,
   dots: false,
  autoplay: false,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1.5,
        }
      }
    ]
});

 $('.recent-deal-inner').slick({
  slidesToShow: 4,
    infinite: true,
  slidesToScroll: 1,
  arrows: true,
   dots: false,
  autoplay: true,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 479,
        settings: {          
            infinite: false,
          autoplay: false,
          slidesToShow: 1.5,
        }
      }
    ]
});

$('.trusted-partners-wrapper').slick({
  slidesToShow: 6,
    infinite: true,
  slidesToScroll: 1,
  arrows: false,
   dots: false,
  autoplay: true,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
        }
      },
     {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
});

$(document).ready(function() {
    $(".recent-reviews-products").on("click", function(e) {
        e.preventDefault(); // Prevent default behavior

        $("html, body").animate({
            scrollTop: $(".customer-review-outer").offset().top - 80
        }, 800); // Adjust speed (800ms for smooth scrolling)
    });
});
$(document).ready(function () {

  function handleNewsletterSuccess() {
    if (
      window.location.href.includes("customer_posted") ||
      window.location.href.includes("newsletter-popup") ||
      window.location.href.includes("form_type=customer")
    ) {
      $(".newsletter-success").addClass("modal--is-active");
      $(".newsletterpopupsimple").removeClass("modal--is-active");
      $("html").addClass("modal-open");
    }
  }
  handleNewsletterSuccess();
  setTimeout(function () {
    handleNewsletterSuccess();
  }, 2000);

  $(document).on("click", ".modal__close", function () {
    $(".newsletter-success").removeClass("modal--is-active");
    $("html").removeClass("modal-open");
  });

});


jQuery(document).ready(function($) {
  $(".compatible_vehicles_popup_scroll").mCustomScrollbar({});
    // Open popup
    $(".compatible_vehicles_btn").on("click", function() {
        $(".compatible_vehicles_popup_outer").addClass("active");
    });

    // Close popup when clicking on overlay or close icon
    $(".compatible_vehicles_popup_outer, .close-icon").on("click", function() {
        $(".compatible_vehicles_popup_outer").removeClass("active");
    });

    // Prevent closing when clicking inside popup content
    $(".compatible_vehicles_popup_content").on("click", function(event) {
        event.stopPropagation();
    });

    $(".discountcode").click(function () {
        var $this = $(this);
        navigator.clipboard.writeText($this.text().trim()).then(function () {
            $this.attr("data-tooltip", "Gekopieerd naar klembord");
            setTimeout(function () {
                $this.removeAttr("data-tooltip");
            }, 1500);
        });
    });
    
    
});


document.addEventListener("DOMContentLoaded", function () {
  const scrollContainer = document.querySelector(".all-collectionsscroll");
  const activeItem = scrollContainer?.querySelector(".collections-single.active");

  if (!scrollContainer || !activeItem) return;

  const containerRect = scrollContainer.getBoundingClientRect();
  const activeRect = activeItem.getBoundingClientRect();

  // Scroll so active item aligns to LEFT
  const offset =
    activeRect.left -
    containerRect.left +
    scrollContainer.scrollLeft;

  scrollContainer.scrollTo({
    left: offset,
    behavior: "smooth"
  });
});



(function () {
    let stickyAtcHasShown = false;
    let updateTimer = null;

    function restoreScrollPosition(scrollY) {
        if (scrollY <= 0) return;
        window.scrollTo({ top: scrollY, left: 0, behavior: "auto" });
    }

    function guardScrollPosition(scrollY, durationMs) {
        if (scrollY <= 0) return;

        const end = Date.now() + durationMs;
        const tick = function () {
            if (window.scrollY !== scrollY) {
                restoreScrollPosition(scrollY);
            }
            if (Date.now() < end) {
                requestAnimationFrame(tick);
            }
        };
        requestAnimationFrame(tick);
    }

    function updateStickyATC() {
        const wrapper = document.querySelector(".zrx-sticky-atc-content-wrapper");
        if (!wrapper) return;

        const button = wrapper.querySelector(".zrx-sticky-atc-main-button");
        const priceWrapper = wrapper.querySelector(".zrx-sticky-atc-product-price-wrapper");
        if (!button || !priceWrapper) return;

        const scrollY = window.scrollY;

        const showWrapper = function () {
            wrapper.style.display = "block";
            wrapper.style.visibility = "visible";
            wrapper.style.opacity = "1";
            stickyAtcHasShown = true;
            restoreScrollPosition(scrollY);
        };

        if (stickyAtcHasShown) {
            showWrapper();
        } else {
            setTimeout(showWrapper, 200);
        }

        if (!button.querySelector(".zrx-custom-wrapper")) {
            const customDiv = document.createElement("span");
            customDiv.className = "zrx-custom-wrapper";
            customDiv.appendChild(priceWrapper.cloneNode(true));
            button.appendChild(customDiv);
        }

        const comparePriceEl = wrapper.querySelector(".zrx-sticky-atc-compare-price");
        const priceEl = wrapper.querySelector(".zrx-sticky-atc-product-price");

        if (comparePriceEl && priceEl) {
            const comparePrice = parseFloat(comparePriceEl.innerText.replace(/[^\d.]/g, ""));
            const price = parseFloat(priceEl.innerText.replace(/[^\d.]/g, ""));

            if (!isNaN(comparePrice) && !isNaN(price) && comparePrice > price) {
                const discountPercentage = ((comparePrice - price) / comparePrice) * 100;
                const whole = Math.floor(discountPercentage);
                const decimal = discountPercentage - whole;
                const displayDiscount = decimal >= 0.5 ? whole + 1 : whole;

                if (!button.querySelector(".zrx-discount-badge")) {
                    const badge = document.createElement("span");
                    badge.className = "zrx-discount-badge";
                    badge.innerText = displayDiscount + "% KORTING";
                    button.appendChild(badge);
                }
            }
        }

        if (!wrapper.querySelector(".btn-tagline")) {
            const tagline = document.createElement("div");
            tagline.className = "btn-tagline";
            tagline.innerHTML = "30 dagen <strong>gratis</strong> uitproberen";

            const actionsWrapper = wrapper.querySelector(".zrx-sticky-atc-product-actions-wrapper");
            if (actionsWrapper) {
                actionsWrapper.appendChild(tagline);
            }
        }

        restoreScrollPosition(scrollY);
    }

    function scheduleUpdateStickyATC() {
        clearTimeout(updateTimer);
        updateTimer = setTimeout(updateStickyATC, 80);
    }

    function observeStickyBar() {
        const bar = document.querySelector(".zrx-sticky-atc-bar");
        if (!bar) {
            setTimeout(observeStickyBar, 500);
            return;
        }

        const observer = new MutationObserver(function (mutations) {
            const domChanged = mutations.some(function (mutation) {
                return mutation.type === "childList" &&
                    (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0);
            });
            if (domChanged) {
                scheduleUpdateStickyATC();
            }
        });

        observer.observe(bar, { childList: true, subtree: true });
    }

    setTimeout(updateStickyATC, 1800);
    observeStickyBar();

    ["cart:updated", "cart:change", "vs-cart-drawer:updated", "vs-cart-drawer:change"].forEach(function (eventName) {
        document.addEventListener(eventName, scheduleUpdateStickyATC);
    });

    document.addEventListener("click", function (event) {
        if (!event.target.closest(".zrx-sticky-atc-main-button")) return;

        const scrollY = window.scrollY;
        guardScrollPosition(scrollY, 2000);
        setTimeout(scheduleUpdateStickyATC, 300);
        setTimeout(scheduleUpdateStickyATC, 1000);
    }, true);
})();



document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 767) {
    document.querySelectorAll(".collections-single span").forEach(el => {
      if (el.textContent.trim() === "Telefoonhouders") {
        el.textContent = "Telefoon houders";
      }
    });
  }
});


// document.addEventListener("DOMContentLoaded", () => {

//     const container = document.querySelector(".product-upsell-list__grid");
//     if (!container) return;

//     let items = Array.from(container.querySelectorAll(".product-upsell-list__item"));

//     if (items.length === 0) return;

//     let currentItem = container.querySelector(".product-upsell-list__item--current");

//     items.sort((a, b) => {
//         const priceA = parseFloat(
//             a.querySelector("strong")?.innerText.replace(/[^\d.]/g, "") || 0
//         );
//         const priceB = parseFloat(
//             b.querySelector("strong")?.innerText.replace(/[^\d.]/g, "") || 0
//         );
//         return priceA - priceB;
//     });

//     items.forEach(item => container.appendChild(item));

//     if (currentItem) {
//         items.forEach(el => el.classList.remove("product-upsell-list__item--current"));
//         currentItem.classList.add("product-upsell-list__item--current");
//     }

// }); 
/* ==========================================================================
   KV FBT upsell — checked .kv-upsell-checkbox adds that variant with main ATC
   Intercepts ATC button click (capture) so it always runs with the buy button.
   ========================================================================== */
(function () {
  var kvBusy = false;

  function kvGetUpsellId() {
    var checkbox = document.querySelector('.kv-upsell-checkbox');
    if (!checkbox || !checkbox.checked || checkbox.disabled) return null;
    return parseInt(checkbox.getAttribute('data-kv-upsell-variant'), 10) || null;
  }

  function kvCartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) return theme.routes.cartAdd;
    return '/cart/add.js';
  }

  function kvAddJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function kvGetQty(form) {
    var qty = 1;
    if (!form) return qty;
    var qtyField = form.elements['quantity'];
    if (qtyField && qtyField.value) {
      qty = parseInt(qtyField.value, 10) || 1;
    } else {
      var qtyChecked = document.querySelector('input[name="quantity"]:checked');
      if (qtyChecked) qty = parseInt(qtyChecked.value, 10) || 1;
    }
    return qty;
  }

  function kvGetMainId(form) {
    if (!form) return null;
    var idEl = form.querySelector('[name="id"]');
    return idEl ? parseInt(idEl.value, 10) || null : null;
  }

  function kvOpenDrawer(form, product, btn) {
    if (btn) btn.classList.remove('btn--loading');
    if (form) {
      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product: product, addToCartBtn: btn }
      }));
    }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function kvAddMainAndUpsell(form, btn, mainId, upsellId, qty) {
    if (kvBusy) return;
    kvBusy = true;
    if (btn) btn.classList.add('btn--loading');

    var url = kvCartAddUrl();

    kvAddJson(url, { id: mainId, quantity: qty })
      .then(function (mainData) {
        if (mainData && mainData.status === 422) throw mainData;
        return kvAddJson(url, { id: upsellId, quantity: 1 })
          .then(function () { return mainData; })
          .catch(function () { return mainData; });
      })
      .then(function (product) {
        kvOpenDrawer(form, product, btn);
      })
      .catch(function (err) {
        console.error('kv upsell ATC error:', err);
        if (btn) btn.classList.remove('btn--loading');
      })
      .finally(function () {
        kvBusy = false;
      });
  }

  // Main buy button — only take over when upsell checkbox is checked
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled) return;
    if (btn.closest('.zrx-sticky-atc-bar, .zrx-sticky-atc-content-wrapper')) return;

    var upsellId = kvGetUpsellId();
    if (!upsellId) return;

    var form = btn.form || btn.closest('form.product-single__form') || document.querySelector('form.product-single__form');
    var mainId = kvGetMainId(form);
    if (!mainId) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    kvAddMainAndUpsell(form, btn, mainId, upsellId, kvGetQty(form));
  }, true);

  // Also catch form submit (keyboard / other triggers)
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.classList || !form.classList.contains('product-single__form')) return;

    var upsellId = kvGetUpsellId();
    if (!upsellId) return;

    var mainId = kvGetMainId(form);
    if (!mainId) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var btn = form.querySelector('[data-add-to-cart]');
    kvAddMainAndUpsell(form, btn, mainId, upsellId, kvGetQty(form));
  }, true);

  // Sticky ATC app
  document.addEventListener('click', function (evt) {
    if (!evt.target.closest('.zrx-sticky-atc-main-button')) return;
    var upsellId = kvGetUpsellId();
    if (!upsellId || kvBusy) return;

    kvBusy = true;
    setTimeout(function () {
      kvAddJson(kvCartAddUrl(), { id: upsellId, quantity: 1 })
        .then(function (data) {
          if (data && data.status === 422) return;
          var form = document.querySelector('form.product-single__form');
          kvOpenDrawer(form, data, null);
        })
        .catch(function () {})
        .finally(function () {
          kvBusy = false;
        });
    }, 1100);
  }, true);
})();
